__turbopack_context__.v({
  "freeMonthyCredit": "PlanCard-module__byix9a__freeMonthyCredit",
  "recommendCard": "PlanCard-module__byix9a__recommendCard",
  "recommendMonthlyCredits": "PlanCard-module__byix9a__recommendMonthlyCredits",
  "subscriptionMonthlyCredit": "PlanCard-module__byix9a__subscriptionMonthlyCredit",
});
